import { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from 'forms/rrf';
import { Col, Row } from 'react-bootstrap';
import FileUpload from '../../../components/common/form/elements/file-upload';
import FileUploadFileList from '../../../components/common/form/elements/file-upload-file-list';
import RequiredInput from '../../../components/common/form/elements/required-input';

class NumberOfPacksSold extends Component {
  handleFileUpload = (file) => {
    const { model, dispatch } = this.props;

    dispatch(actions.push(
      `${model}.proof_of_purchases_attributes`,
      { [Date.now()]: { persisted: false, proof_of_purchase: file } }
    ));
  };

  render() {
    const {
      model,
      evidenceType,
      brands,
      formData
    } = this.props;

    return (
      <div>
        <Row>
          <Col md={12}>
            Number of packs sold*
          </Col>
        </Row>
        {brands && brands.map((brand, index) => (
          <Row className="brand" key={index}>
            <Col md={6} xs={12} className="text">{brand.label}</Col>
            <Col md={6} xs={12}>
              <RequiredInput
                model={`${model}.brands.${brand.value}`}
                type="number"
                placeholder="Number of packs sold"
                min={0}
                step={1}
                positive={false}
              />
            </Col>
          </Row>
        ))}
        <Row>
          <Col md={12}>
            <div className="space-text">
              Your rep has indicated you will provide
              <span className="bold-text">
                {` ${evidenceType} `}
              </span>
              to support your submission.
              Please upload your documentation below, note you can upload multiple documents.
            </div>
            <FileUpload
              label=""
              model={`${model}.proof_of_purchases`}
              showFileNameInTextField={false}
              onFileLoaded={this.handleFileUpload}
              multi
              required
            />
            <div style={{ marginBottom: '20px' }}>
              <FileUploadFileList
                data={formData.proof_of_purchases_attributes}
                model={`${model}.proof_of_purchases_attributes`}
                fileName={'proof_of_purchase'}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.postcodePlanObjective,
});

export default connect(mapStateToProps)(NumberOfPacksSold);
